import { Typography } from '@tempmee/react';
import { BackButtonProxy } from '../BackButton';
import { Box } from '../Box';
import { Center } from '../Center';
import { ZStack } from '../ZStack';

interface IScreenTitleProps {
  title: string;
  onBackClick: () => void;
}

export const ScreenTitle = ({ title, onBackClick }: IScreenTitleProps) => (
  <Box data-testid="screen-title" position="relative" marginBottom={32} marginTop={60} width="100%">
    <Center>
      <ZStack left={20}>
        <BackButtonProxy onClick={onBackClick} />
      </ZStack>

      <Typography as="span" size="heading_2" bold textAlign="center">
        {title}
      </Typography>
    </Center>
  </Box>
);
